import { INTERNAL_EMAIL_DOMAINS } from "../common/constants";

export const NAME = "user";

export const isInternalUser = (email: string) =>
  INTERNAL_EMAIL_DOMAINS.some(
    (domain: string) => email && email.includes(domain)
  );



// WEBPACK FOOTER //
// ./client/modules/User/constants.ts